import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { QuoteIcon, StarIcon, ShieldCheckIcon } from 'lucide-react';
export function TestimonialSection() {
  const testimonials = [{
    name: 'Mariana G.',
    role: 'Profesora de Educación Física',
    quote: 'Material muy claro y bien organizado. Me ayudó a trabajar con más seguridad en clase. Lo uso todo el tiempo.'
  }, {
    name: 'Lucas R.',
    role: 'Entrenador Personal',
    quote: 'Lo que más valoro es lo visual. Las imágenes ayudan muchísimo a explicar mejor los ejercicios.'
  }, {
    name: 'Florencia M.',
    role: 'Profesora de Ed. Física',
    quote: 'Tenía información, pero desordenada. Este pack me dio claridad y tranquilidad para planificar sin dudar.'
  }, {
    name: 'Diego S.',
    role: 'Instructor de Musculación',
    quote: 'Se nota que está pensado para usar, no solo para leer. Ideal como material de consulta permanente.'
  }, {
    name: 'Javier L.',
    role: 'Profesor de Educación Física',
    quote: 'El contenido es muy bueno y claro. Me llevó un poco de tiempo recorrer todo el material, pero vale la pena como recurso de apoyo.'
  }, {
    name: 'Carla P.',
    role: 'Entrenadora Personal',
    quote: 'Me ayudó a tomar mejores decisiones y justificar lo que hago frente a mis alumnos.'
  }];
  return <section className="py-10 relative overflow-hidden bg-background-dark" data-id="element-274">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-275">
        <FadeIn className="text-center mb-10" data-id="element-276">
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-white" data-id="element-277">
            Lo que dicen los profesionales
          </h2>
          <p className="text-xl text-gray-400" data-id="element-278">
            Resultados reales de colegas que ya usan la Base Técnica.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-279">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-280">
              <div className="bg-card-dark border border-card-border-dark rounded-2xl p-6 h-full flex flex-col relative overflow-hidden hover:border-primary/30 transition-colors" data-id="element-281">
                <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-primary/10" data-id="element-282" />

                <div className="flex gap-1 mb-4" data-id="element-283">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-secondary text-secondary" data-id="element-284" />)}
                </div>

                <p className="text-lg text-gray-300 italic mb-6 flex-1 relative z-10" data-id="element-285">
                  "{testimonial.quote}"
                </p>

                <div className="relative z-10" data-id="element-286">
                  <p className="font-bold text-white" data-id="element-287">{testimonial.name}</p>
                  <p className="text-primary text-sm font-medium" data-id="element-288">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-289">
          <div className="flex flex-col items-center gap-4 mt-12" data-id="element-290">
            <Button onClick={() => {
            document.getElementById('pricing-cta')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }} className="md:px-12 md:py-5 md:text-2xl" data-id="element-291">
              Ir a la oferta
            </Button>
            <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-292">
              <ShieldCheckIcon className="w-4 h-4 text-green-500" data-id="element-293" />
              <span data-id="element-294">Compra segura. Acceso inmediato.</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}